/**
 * api地址,前端所有api地址均在此定义
 * 代码库中不再直接使用api请求地址
 *
 * @todo 承担api访问功能,信息出错处理 
 * @todo api url 由api提供
 */
//import fetch from 'isomorphic-fetch';

const baseUrl = (process.env.NODE_ENV === 'development') ?  "https://api.localhost" : "api";

const api = {
  index:        baseUrl + '/index.php',
  home:         baseUrl + '/index.php',
  weixin_token: baseUrl + '/index.php',

  //reddit列表api
  reddit: 'https://www.reddit.com/r',
};

export default api;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/api.js